import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-cd5adc3a"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 1,
  class: "OCaracteristicaValorLista",
  "data-testid": "OCaracteristicaValorLista"
}
const _hoisted_2 = { class: "OCaracteristicaValorLista__AdicionarAtributo" }

import { onMounted, ref, computed, watch } from "vue"
  import { storeToRefs } from "pinia"

  import { MDropdown } from "@/components/Gerais"
  import { OCaracteristicaValor } from ".."

  import { CaracteristicaStore } from "@/store/atributos/caracteristicas/caracteristicas.store"

  import AtributosRepositorio from "@/repositorios/atributos/atributos.repositorio"
  import { AtributoBase, ParamsAtributo } from "@/repositorios/atributos/atributos.modelos"

  import { usarBuscarMaisDados} from "@/composable/UsarBuscarMaisDados/usarBuscarMaisDados"
  import { usarLeitorDeDados } from "@/composable/UsarLeitorDeDados/usarLeitorDeDados"

  import { useToast } from "primevue/usetoast"
  import { estados } from "@/types/api"
  import { EntidadeGenerica } from "@/types/gerais"
  import { useI18n } from "vue-i18n"

  interface Props {
    carregando?: boolean
  }

  
export default /*#__PURE__*/_defineComponent({
  __name: 'OCaracteristicaValorLista',
  props: {
    carregando: { type: Boolean }
  },
  setup(__props: any) {

  

  const { t } = useI18n()

  const caracteristicaStore = CaracteristicaStore()
  const { caracteristicas, estagioDaRequisicao } = storeToRefs(caracteristicaStore)
  const { adicionarCaracteristica, removerCaracteristica } = caracteristicaStore

  const atributosRep = new AtributosRepositorio()

  const { buscarMaisDados, filtrarDadosDoRepositorio, atualizarDadosDoRepositorio  } = usarBuscarMaisDados()
  const { leitor } = usarLeitorDeDados()

  const toast = useToast()
  const caracteristicaSelecionada = ref<AtributoBase<string>>()
  const caracteristicasDropdown = ref<AtributoBase[]>([])
  const caracterisiticasEntidadeGenerica = ref<EntidadeGenerica[]>([])

  const estaCarregandoCaracteristicas = computed(() => {
    return lerAtributos.resultado.status === 'pendente'
  })

  const estaCarregandoCaracteristicasStore = computed(() => {
    return estagioDaRequisicao.value === estados.PEDENTE
  })

  const lerAtributos = leitor<AtributoBase, ParamsAtributo>(
    atributosRep.listarAtributos, {
      tipo_do_atributo: "igual.caracteristica",
      "por-pagina": 30
    }
  )

  const atributoDuplicado = (id: string): boolean => {
    return caracteristicas.value.some((caracterisitica) => caracterisitica.id === id)
  }

  const mostrarAvisoDeCaracteristicaDuplicada = (): void => {
    toast.add({
      severity: "info",
      summary: t("duplicado"),
      detail: t("caracteristicaJaFoiAdicionada"),
      closable: true,
      life: 4000,
    })
  }

  const adicionarCaracteristicaNaLista = (): void => {
    const caracteristica = caracteristicaSelecionada.value

    if (caracteristica) {
      const jaTemCaracteristica = atributoDuplicado(caracteristica.id!)

      if (jaTemCaracteristica) {
        mostrarAvisoDeCaracteristicaDuplicada()
      } else {
        adicionarCaracteristica({
          id: caracteristica.id!,
          nomeDoAtributo: caracteristica.nome || "",
          tipoDoValor: caracteristica.tipoDeValor,
          tipoDoAtributo: "caracteristica",
          valor: caracteristica.valor,
          tipoDosValoresDaLista:caracteristica.tipoDosValoresDaLista,
          deletavel: true,
          valoresPossiveis: caracteristica.valoresPossiveis,
        })
      }
    }
  }

  const buscarMaisAtributos = async (): Promise<void> => {
    await buscarMaisDados(lerAtributos, caracterisiticasEntidadeGenerica)
  }

  const filtrarAtributos = async (valorInserido: string): Promise<void> => {
    await filtrarDadosDoRepositorio(valorInserido, lerAtributos, caracterisiticasEntidadeGenerica)
  }

  const listaTodosOsAtributosCaracteristicas = async (): Promise<void> => {
    await lerAtributos.executar()

    if (lerAtributos.resultado.status === "sucesso") {
      caracteristicasDropdown.value = lerAtributos.resultado.dados

      await atualizarDadosDoRepositorio(lerAtributos, caracterisiticasEntidadeGenerica)
    }
  }

  watch(caracterisiticasEntidadeGenerica, () => {
    if (lerAtributos.resultado.status === 'sucesso') {
      caracteristicasDropdown.value = lerAtributos.resultado.dados
    }
  })

  onMounted(async () => {
    await listaTodosOsAtributosCaracteristicas()
  })

return (_ctx: any,_cache: any) => {
  const _component_Skeleton = _resolveComponent("Skeleton")!
  const _component_PButton = _resolveComponent("PButton")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(estaCarregandoCaracteristicasStore) || __props.carregando)
      ? (_openBlock(), _createBlock(_component_Skeleton, {
          key: 0,
          class: "OCaracteristicaValorLista__Skeleton",
          height: "8rem",
          width: "100%"
        }))
      : (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(caracteristicas), (caracteristica) => {
            return (_openBlock(), _createElementBlock("div", {
              key: caracteristica.nomeDoAtributo,
              class: "OCaracteristicaValorLista__AtributoComValor"
            }, [
              _createVNode(_unref(OCaracteristicaValor), {
                modelValue: caracteristica.valor,
                "onUpdate:modelValue": ($event: any) => ((caracteristica.valor) = $event),
                "data-testid": "OCaracteristicaValorLista__Caracteristica",
                "lista-de-multipla-escolha": caracteristica.listaDeMultiplaEscolha,
                nome: caracteristica.nomeDoAtributo,
                "tipo-de-valor": caracteristica.tipoDoValor,
                "valores-possiveis": caracteristica.valoresPossiveis
              }, null, 8, ["modelValue", "onUpdate:modelValue", "lista-de-multipla-escolha", "nome", "tipo-de-valor", "valores-possiveis"]),
              _withDirectives(_createVNode(_component_PButton, {
                onClick: ($event: any) => (_unref(removerCaracteristica)(caracteristica.id)),
                class: _normalizeClass(["OCaracteristicaValorLista__Remover p-button-rounded p-button-text", { 'p-disabled': !caracteristica?.deletavel }]),
                "data-testid": "OCaracteristicaValorLista__Remover",
                disabled: !caracteristica?.deletavel,
                icon: "pi pi-trash"
              }, null, 8, ["onClick", "class", "disabled"]), [
                [
                  _directive_tooltip,
                  _unref(t)('removerCaracteristica'),
                  void 0,
                  { top: true }
                ]
              ])
            ]))
          }), 128))
        ])),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(MDropdown), {
        modelValue: caracteristicaSelecionada.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((caracteristicaSelecionada).value = $event)),
        onOnFiltrandoBusca: filtrarAtributos,
        "buscar-mais-itens": buscarMaisAtributos,
        carregando: _unref(estaCarregandoCaracteristicas),
        class: "OCaracteristicaValorLista__Dropdown",
        desativado: _unref(estaCarregandoCaracteristicasStore) || __props.carregando,
        nome: "adicionar-atributo-caracteristica",
        "option-label": "nome",
        options: caracteristicasDropdown.value,
        placeholder: _unref(t)('atributo'),
        "usar-carregamento-sob-demanda": ""
      }, null, 8, ["modelValue", "carregando", "desativado", "options", "placeholder"]),
      _createVNode(_component_PButton, {
        onClick: adicionarCaracteristicaNaLista,
        class: "OCaracteristicaValorLista__Button p-button-success",
        disabled: _unref(estaCarregandoCaracteristicasStore) || __props.carregando,
        label: _unref(t)('adicionarCaracteristica')
      }, null, 8, ["disabled", "label"])
    ])
  ], 64))
}
}

})